import { render, staticRenderFns } from "./newAnnouncement.vue?vue&type=template&id=39c78abc&"
import script from "./newAnnouncement.vue?vue&type=script&lang=js&"
export * from "./newAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./newAnnouncement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports